import "./style.css";
import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton";
import { useEffect, useState } from "react";
import servEquipamentos from "../../services/login/servEquipamentos";
import { Alert, Box, CircularProgress, FormControl, InputLabel, Modal, Snackbar } from "@mui/material";
import { style as modalStyle } from "../../components/Loading/Loading";
import StatusEquipamento from "../../components/StatusEquipamento";
import Lista from "../../components/Lista";
import Popup from "../../components/Popup";
import Cadastro from "./Cadastro";
import { useDispatch, useSelector } from "react-redux";
import SolicitarHomologacao from "./SolicitarHomologacao";
import SolicitarCancelamento from "./SolicitarCancelamento";
import { useNavigate } from "react-router-dom";
import { logout } from "../../state/slices/userSlice";
import { WhiteInput } from "../../components/Inputs/InputText";
import { ErrorHandling } from "../../components/Errors/Errors";
import { OpcoesTipoDeEquipamento } from "../../components/Combobox/TipoDeEquipamento";
import Select from 'react-select';
import { SearchFieldStyles } from "../../components/Searchfields/SearchFieldStyles";
import ConsultarHomologacao from "./ConsultarHomologacao";
import { OpcoesSituacaoEquipamento } from "../../components/Combobox/SituacaoEquipamento";

const columns = [
    { 
        field: 'Situacao',
        headerName: 'Status', 
        flex: 0.3,
        renderCell: (params) => (
            <StatusEquipamento value={params.value} />
        )
    },
    { field: 'id', headerName: 'Código', flex: 0.3},
    { field: 'Fabricante', headerName: 'Fabricante', flex: 1, 
        renderCell: (params) => {
            var fabricante = params?.row?.Fabricante?.trim() ? params?.row?.Fabricante : params?.row?.Fabricantes?.NomeFabricante;

            return fabricante;
        }
    },
    { field: 'Modelo', headerName: 'Modelo', flex: 1},
    { field: 'Descricao', headerName: 'Descrição', flex: 1.5 },
    { field: 'NumeroFases', headerName: 'Nº de fases', flex: 0.4, 
        renderCell: (params) => {
            switch (Number(params.value)) {
                case 1: 
                    return "Monofásica";
                case 2:
                    return "Bifásica";
                case 3:
                    return "Trifásica";
                default:
                    return "Não se aplica";
            }
        }
    },
    { field: 'Tipo', headerName: 'Tipo', flex: 0.4,
        renderCell: (params) => {
            switch (params.value) {
                case 1: 
                    return "Módulo";
                case 2:
                    return "Inversor";
                default:
                    return "Outros";
            }
        }
    },
    { field: 'PotenciaKw', headerName: 'Potência (kW)', flex: 0.3 },
    { field: 'tensaoFornecimento', headerName: 'Tensão nominal', flex: 0.6,
        renderCell: (params) => {
            var codigoTensaoFornecimento = params?.row?.CodigoTensaoFornecimento

            if(codigoTensaoFornecimento) {
                var tensaoFornecimento = params?.row?.TensaoFornecimento;

                return `${codigoTensaoFornecimento} - ${tensaoFornecimento?.Descricao}`
            }

            return '';
        }
    },
]

const Equipamentos = ({ popupLista=false, setSelectedData, onDblClick }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(state => state.user);
    
    const [filtro, setFiltro] = useState("");
    const [tipoEquipamento, setTipoEquipamento] = useState([]);
    
    const [equipamentos, setEquipamentos] = useState([]);
    const [openErrorWindow, setOpenErrorWindow] = useState(false);
    const [severity, setSeverity] = useState("warning");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [openPopup, setOpenPopup] = useState(false);
    const [recordForEdit, setRecordForEdit] = useState(null);
    const [openHomologacao, setOpenHomologacao] = useState(false);
    const [openCancelamento, setOpenCancelamento] = useState(false);
    const [openConsultaHomolog, setOpenConsultaHomolog] = useState(false);

    const [situacaoEquipamento, setSituacaoEquipamento] = useState([]);
    const [filtroCodigo, setFiltroCodigo] = useState("");

    const [cssEsconderBotoes, setCssEsconderBotoes] = useState({});
    const [pageSize, setPageSize] = useState(100);


    // #region Effects documentar melhor futuramente 

    useEffect(() => {
        const listarDados = async ( ) => {

            try {
                
                setIsLoading(true);
                
                let dados = await servEquipamentos.listar(user.codigoUsuario, "");

                
                dados.Content && dados.Content.map((equipamento) => {
                    return equipamento.id = equipamento.Id
                });
                
                setIsLoading(false);

                setEquipamentos(dados.Content);
            } catch (err) {
                setIsLoading(false);

                if (err.response.status === 401) {
                    setErrorMessage("Token expirado, redirecionando...");
                    setOpenErrorWindow(true);
                    return setTimeout(() => {
                        dispatch(logout());
                        navigate("/");
                    }, [2000]);
                }

                setErrorMessage(err.Message);
                setOpenErrorWindow(true);
            }

        }

        // if (equipamentos.length === 0) {
        listarDados();
        // }

        if (popupLista) {
            setCssEsconderBotoes({display: 'none'});
            setPageSize(20);
        }

    }, []);

    useEffect(() => {
        if (openPopup === false) {

        }

    }, [openPopup]);

    // #endregion Fim dos Effects

    // #region Funções

    const onClickPesquisar = () => {
        const listarDados = async ( ) => {

            try {
                
                setIsLoading(true);
                
                let dados;

                if (tipoEquipamento.length === 0 && situacaoEquipamento.length === 0 && filtroCodigo === "") {
                    dados = await servEquipamentos.listar(user.codigoUsuario, filtro);
                } else {
                    let arrayTipos = [];
                    let arraySituacoes = [];
                
                    arrayTipos = tipoEquipamento.map((item) => item.value);
                    arraySituacoes = situacaoEquipamento.map((item) => item.value);
                    
                    dados = await servEquipamentos.listarCfeTipoOuSituacao(user.codigoUsuario, filtro, arrayTipos, arraySituacoes, filtroCodigo);
                }
                
                dados.Content && dados.Content.map((equipamento) => {
                    return equipamento.id = equipamento.Id
                });
                
                setIsLoading(false);

                setEquipamentos(dados.Content);
            } catch (err) {
                setIsLoading(false);
                setSeverity("error");

                return ErrorHandling(
                    err?.response?.status, 
                    err?.Message, 
                    setOpenErrorWindow, 
                    setErrorMessage, 
                    dispatch, 
                    logout, 
                    navigate,
                    err?.response?.data?.Message
                );
            }

        }

        listarDados();
    }

    const adicionarOuEditar = async (equipamento) => {
        let id; 
        if (equipamento.Id == 0) {
            const response = await servEquipamentos.inserir(
                equipamento.descricao,
                equipamento.fabricante,
                equipamento.modelo,
                equipamento.fases,
                equipamento.tipo,
                equipamento.possuiafci,
                equipamento.codigoUsuario,
                equipamento.dataCertificacao,
                equipamento.potencia
            );

            id = response.Content.Id;
        } else {
            const response = await servEquipamentos.editar(
                equipamento.Id,
                equipamento.descricao,
                equipamento.fabricante,
                equipamento.modelo,
                equipamento.fases,
                equipamento.tipo,
                equipamento.possuiafci,
                equipamento.codigoUsuario,
                equipamento.dataCertificacao,
                equipamento.potencia
            )

            id = response.Content.Id;
        }

        setRecordForEdit(null);

        return id;
    }

    const handleCloseError = (event, reason) => {
        if (reason  === 'clickaway') {
            setOpenErrorWindow(false);
        }

        setOpenErrorWindow(false);
    }

    const solicitarHomologacao = () => {
        if (recordForEdit === null) {
            setSeverity("warning");
            setErrorMessage("É necessário selecionar um registro")
            return setOpenErrorWindow(true);
        }

        const situacoesHomologaveis = [0, 2];

        if (situacoesHomologaveis.includes(recordForEdit?.row?.Situacao) || situacoesHomologaveis.includes(recordForEdit?.Situacao)) {
            return setOpenHomologacao(true);
        }

        setSeverity("warning");
        setErrorMessage("Só é possível homologar equipamentos com situação em digitação ou revisão")
        return setOpenErrorWindow(true);
    }

    const solicitarCancelamento = () => {
        if (recordForEdit === null) {
            setSeverity("warning");
            setErrorMessage("É necessário selecionar um registro");
            return setOpenErrorWindow(true);
        }

        const situacoesCancelaveis = [0, 1, 2];

        if (situacoesCancelaveis.includes(recordForEdit?.row?.Situacao) || situacoesCancelaveis.includes(recordForEdit?.Situacao)) {
            if(user.codigoUsuario !== (recordForEdit?.row?.CodigoResponsavelTecnico || recordForEdit?.CodigoResponsavelTecnico)) {
                setSeverity("warning");
                setErrorMessage("Não é possível cancelar, este equipamento foi criado por outro responsável técnico");
                return setOpenErrorWindow(true);
            }

            return setOpenCancelamento(true);
        }

        setSeverity("warning");
        setErrorMessage("Só é possível cancelar equipamentos com situação em digitação, pendente de homologação ou revisão");
        return setOpenErrorWindow(true);
    }

    const consultarHomologacao = () => {
        if (recordForEdit === null) {
            setSeverity("warning");
            setErrorMessage("É necessário selecionar um registro");
            return setOpenErrorWindow(true);
        }

        const situacoesCancelaveis = [0];

        if (situacoesCancelaveis.includes(recordForEdit?.row?.Situacao) || situacoesCancelaveis.includes(recordForEdit?.Situacao)) {
            setSeverity("warning");
            setErrorMessage("Para consultar a homologação, o equipamento não pode estar em digitação.");
            return setOpenErrorWindow(true);
        }
    
        return setOpenConsultaHomolog(true);
    }

    const adicionarNovoEquipamento = () => {
        setRecordForEdit(null);
        setOpenPopup(true);
    }

    // #endregion Fim das funções

    return (
        <div className="equipamentos-container">
            <div className="equipamentos-filtros">
                <FormControl variant="outlined">
                    <InputLabel shrink style={{ color: "#B8B8B8" }}>
                        Pesquisa geral
                    </InputLabel>
                    <WhiteInput value={filtro} onChange={(e) => setFiltro(e.target.value)} placeholder="Nome" id="pesquisa-nome-equipamentos" sx={{ width: "488px", margin: '0px 18px' }} />
                </FormControl>
            </div>
            <div className="equipamentos-filtros" style={{ margin: "20px 0 0 18px" }}>
                <FormControl variant="outlined" sx={{ width: "270px", zIndex: "100" }}>
                    <InputLabel htmlFor="pesquisa-nome-equipamentos" shrink style={{ color: "#B8B8B8" }}>
                        Tipo do equipamento
                    </InputLabel>
                    <Select
                        isMulti={true}
                        value={tipoEquipamento}
                        onChange={value => setTipoEquipamento(value)}
                        options={OpcoesTipoDeEquipamento}
                        styles={SearchFieldStyles}
                        placeholder="Selecione o tipo"
                    />
                </FormControl>

                <FormControl>
                    <InputLabel shrink style={{ color: "#B8B8B8", marginLeft: "10px" }} >Equipamento</InputLabel>
                    <WhiteInput 
                        value={filtroCodigo} 
                        onChange={(e) => setFiltroCodigo(e.target.value)} 
                        placeholder="Equipamento" 
                        id="pesquisa-codigo" 
                        sx={{ width: "200px", margin: '0px 18px' }} 
                        type="number"
                    />
                </FormControl>
            </div>
            <div className="equipamentos-filtros">
                <FormControl variant="outlined" sx={{ width: "486px", margin: "20px 0 0 20px" }}>
                    <InputLabel htmlFor="pesquisa-nome-situacao" shrink style={{ color: "#B8B8B8", zIndex: "1" }}>
                        Situação
                    </InputLabel>
                    <Select     
                        isMulti={true}
                        value={situacaoEquipamento}
                        onChange={value => setSituacaoEquipamento(value)}
                        options={OpcoesSituacaoEquipamento}
                        styles={SearchFieldStyles}
                        placeholder="Situação"
                    />
                </FormControl>
                <BlueHoverButton variant="contained" onClick={onClickPesquisar} style={{ marginLeft: '20px', marginBottom: '5px', marginTop: "40px" }}>
                    Pesquisar
                </BlueHoverButton>
            </div>
            
            <div className="equipamentos-botoes">
                <BlueHoverButton style={cssEsconderBotoes} variant="contained" onClick={adicionarNovoEquipamento}>Novo equipamento</BlueHoverButton>
                <BlueHoverButton style={cssEsconderBotoes} variant="contained" onClick={solicitarHomologacao}>Solicitar homologação</BlueHoverButton>
                <BlueHoverButton style={cssEsconderBotoes} variant="contained" onClick={consultarHomologacao}>Consultar homologação</BlueHoverButton>
                <BlueHoverButton style={cssEsconderBotoes} variant="contained" onClick={solicitarCancelamento}>Cancelar solicitação</BlueHoverButton>
            </div>

            <div className="equipamentos-lista" style={ popupLista ? { height: '430px' } : {}}>
                <Modal open={isLoading}>
                    <Box style={modalStyle}>
                        <CircularProgress color="inherit" />
                    </Box>
                </Modal>
                <Lista 
                    columns={columns} 
                    rows={equipamentos} 
                    pageSize={pageSize}
                    setSelectedData={setSelectedData ? setSelectedData : setRecordForEdit} 
                    onDblClick={onDblClick ? onDblClick : setOpenPopup}
                />
                <Popup title="Equipamentos" openPopup={openPopup} setOpenPopup={setOpenPopup}>
                    <Cadastro 
                        setOpenPopup={setOpenPopup} 
                        recordForEdit={recordForEdit}
                        addOrEdit={adicionarOuEditar}   
                        pesquisar={onClickPesquisar} 
                        origemSolicitacao={false}
                    />
                </Popup>
                <Popup title="Solicitar homologação" openPopup={openHomologacao} setOpenPopup={setOpenHomologacao} minHeight="100px">
                    <SolicitarHomologacao 
                        setOpenPopup={setOpenHomologacao} 
                        recordForEdit={recordForEdit}
                        pesquisar={onClickPesquisar}
                    />
                </Popup>
                <Popup title="Homologação" openPopup={openConsultaHomolog} setOpenPopup={setOpenConsultaHomolog} minHeight="100px">
                    <ConsultarHomologacao
                        setOpenPopup={setOpenConsultaHomolog}
                        recordForEdit={recordForEdit}
                        pesquisar={onClickPesquisar}
                    />
                </Popup>
                <Popup title="Solicitar cancelamento" openPopup={openCancelamento} setOpenPopup={setOpenCancelamento} minHeight="100px">
                    <SolicitarCancelamento
                        setOpenPopup={setOpenCancelamento}
                        recordForEdit={recordForEdit}
                        pesquisar={onClickPesquisar}
                    />
                </Popup>
                <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}> 
                    <Alert onClose={handleCloseError} severity={severity} sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
                </Snackbar>
            </div>
        </div>
    )
}



export { Equipamentos }